import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const Index = lazy(() => import('./pages/index'));

const routes = [
  {
    url: '/',
    component: Index
  },
];

export default function CreateRoutes() {
  return (
    <Routes>
      {
        routes.map((item, index) => {
          const Component = item.component;
          return (
            <Route
              key={index}
              path={item.url}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <Component />
                </Suspense>
              }
            />
          );
        })
      }
    </Routes>
  );
}